import { useNavigate } from "react-router-dom"
import { Data, DataTypeForm, dateToString, useDescribeHooks } from "../../../../../features/data-types"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelWrapper, useGetCrumbs } from "../../../../../features/ui"
import { Check, CheckType } from "../../../state/types"
import { useActions } from "./actions"
import { CheckFields } from "../check-fields/checkFields"
import { TableName } from "../../../../../tables"

export const CheckForm = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const check = dataType as O<Check>
    const createMode = !check

    const navigate = useNavigate()
    const { describe } = useDescribeHooks()

    const { submitCheck } = useActions()

    const checkLabel = check ? describe(TableName.CHECKS, check) : undefined
    const checkTitleLabel = check ? `: ${checkLabel}` : undefined
    const title = `${createMode ? 'Crear' : 'Editar'} ${checkTitleLabel || 'Cheque'}`
    const crumbs = useGetCrumbs(
        'Cheques',
        RoutePath.CHECKS,
        check?.name,
        check?.id,
        createMode ? 'Crear' : 'Editar'
    )

    const fields = CheckFields({
        type: CheckType.PHYSICAL,
        issueDate: dateToString(new Date()),
        paymentDate: dateToString(new Date()),
        endorsable: true
    })

    const onSubmit = (checkData: Data) => submitCheck(checkData, createMode)

    const onCancel = () => navigate(-1)

    return (
        <PanelWrapper title={title} crumbs={crumbs}>
            <DataTypeForm
                formId="check-form"
                fields={fields}
                defaultDataType={check}
                createMode={createMode}
                onSubmit={onSubmit}
                onCancel={onCancel}
            />
        </PanelWrapper>
    )
}
